// src/modules/Produto/boot/bootProdutoCategoria.js
import { mergeIfEmpty } from '../../../../boot/utils';

export const bootProdutoCategoria = ({ prev, categoria, parametro }) => {
    if (!categoria) return prev;

    let patch = {};
    const pessoaPadrao = parametro?.pessoaPadrao;
    const ncmBobina = parametro?.ncmBobina;
    const ncmImovel = parametro?.ncmImovel;

    switch (categoria) {
        case 'materia-prima':
            patch = {
                venda: false,
                compra: true,
                tipo: 'Uso Consumo',
                materiaPrima: true,
            };
            break;

        case 'produto':
            patch = {
                venda: true,
                compra: true,
                tipo: 'Material',
            };
            break;

        case 'vtr':
            patch = {
                venda: false,
                compra: false,
                bem: true,
                vtr: true,
                ativo: true,
                tipo: 'Imobilizado',
                produtoBens: { tipo: 'Móvel', ativo: true },
            };
            break;

        case 'imovel':
            patch = {
                venda: false,
                compra: false,
                bem: true,
                imovel: true,
                ativo: true,
                tipo: 'Imobilizado',
                fabricanteId: pessoaPadrao?.id,
                ...(pessoaPadrao?.id
                    ? {
                          fabricanteId: pessoaPadrao?.id,
                          Fabricante: { id: pessoaPadrao?.id, descricao: pessoaPadrao?.descricao },
                      }
                    : {}),
                ...(ncmImovel?.id
                    ? {
                          NCM: ncmImovel,
                          ncmId: ncmImovel?.id,
                      }
                    : {}),
                produtoBens: { tipo: 'Imóvel', ativo: true },
            };
            break;

        case 'bobina':
            patch = {
                isBobina: true,
                //1ª div cabeçalho
                industria: true,
                materiaPrima: true,

                tipo: 'Uso Consumo',
                fabricanteId: pessoaPadrao?.id,
                ...(pessoaPadrao?.id
                    ? {
                          fabricanteId: pessoaPadrao?.id,
                          Fabricante: { id: pessoaPadrao?.id, descricao: pessoaPadrao?.descricao },
                      }
                    : {}),
                ...(ncmBobina?.id
                    ? {
                          NCM: ncmBobina,
                          ncmId: ncmBobina?.id,
                      }
                    : {}),
            };
            break;

        default:
            break;
    }

    return mergeIfEmpty(prev, patch);
};
